import get from "lodash/fp/get";

const selectSkatePlayerNumber = get([
  "app",
  "userChoiceValues",
  "playerNumber",
]);

export default selectSkatePlayerNumber;
